import { Text, View } from '@mirai/ui';
import React from 'react';

import * as style from './routes.module.css';

export const Finder = () => (
  <>
    <View tag="section" className={[style.section, style.box, style.accent]}>
      <View className={(style.wrapper, style.centered)}>
        <Text bold headline level={1}>
          Finder
        </Text>
      </View>
    </View>
    <View className={[style.wrapper, style.box]}>
      <View data-mirai-component="finder" data-layout="column" className={style.column} />
    </View>
  </>
);
